type Props = {
  className?: string;
};

export const ChatAgentCheckIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1411_31889)">
        <path
          d="M7.99972 16C6.14888 15.9999 4.35533 15.3581 2.92465 14.1839C1.49397 13.0097 0.514697 11.3757 0.153678 9.56046C-0.207342 7.74517 0.0722327 5.86086 0.944765 4.2286C1.8173 2.59633 3.2288 1.3171 4.93878 0.608871C6.64875 -0.0993615 8.55139 -0.192774 10.3225 0.344548C12.0936 0.881871 13.6237 2.01668 14.6519 3.55563C15.6801 5.09457 16.1429 6.94243 15.9615 8.78436C15.78 10.6263 14.9655 12.3483 13.6567 13.657C12.9154 14.402 12.0338 14.9927 11.0628 15.3948C10.0918 15.797 9.0507 16.0027 7.99972 16ZM3.99972 7C3.85222 6.99992 3.70798 7.04332 3.58502 7.12479C3.46207 7.20626 3.36586 7.32218 3.30844 7.45804C3.25102 7.5939 3.23494 7.74368 3.2622 7.88863C3.28947 8.03359 3.35887 8.16728 3.46172 8.273L6.12772 11.023C6.19762 11.095 6.28126 11.1522 6.37367 11.1913C6.46608 11.2303 6.56539 11.2505 6.66572 11.2505C6.76605 11.2505 6.86536 11.2303 6.95777 11.1913C7.05018 11.1522 7.13382 11.095 7.20372 11.023L12.5387 5.523C12.6669 5.37849 12.7344 5.19008 12.7272 4.99704C12.7199 4.80399 12.6384 4.62118 12.4997 4.48672C12.361 4.35226 12.1757 4.27652 11.9826 4.27526C11.7894 4.27401 11.6032 4.34735 11.4627 4.48L6.66272 9.424L4.53572 7.23C4.46651 7.15749 4.38335 7.09973 4.29123 7.06021C4.19912 7.02068 4.09996 7.0002 3.99972 7Z"
          fill="#0133cd"
        />
      </g>
      <defs>
        <clipPath id="clip0_1411_31889">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
